import { useEffect } from 'react';
import { TRANSLATIONS } from './settings';

const ATTRIBUTES = ['placeholder', 'title', 'aria-label', 'alt'];
const SKIP_TEXT_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'IFRAME', 'CANVAS', 'INPUT', 'TEXTAREA']);
const SKIP_ATTRIBUTE_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'IFRAME', 'CANVAS']);

const UI_PHRASES = [
  ['Back to home', 'Zur Startseite'],
  ['Sign out', 'Abmelden'],
  ['Signed out', 'Abgemeldet'],
  ['Dismiss', 'Ausblenden'],
  ['Reopen this campaign', 'Diese Kampagne erneut oeffnen'],
  ['Reset to demo data', 'Demo-Daten zuruecksetzen'],
  ['Interactive Engine', 'Interaktive Engine'],
  ['Grounded Knowledge Base', 'Fundierte Wissensbasis'],
  ['Teach the AI about your company. Generated content is grounded on the profile, products and documents you provide here, with source context shown where available. Always review final claims before publishing.', 'Bring der KI dein Unternehmen bei. Generierte Inhalte basieren auf dem Profil, den Produkten und den Dokumenten, die du hier hinterlegst. Quellenkontext wird angezeigt, wenn er verfuegbar ist. Pruefe finale Aussagen vor der Veroeffentlichung.'],
  ['Active company', 'Aktives Unternehmen'],
  ['New company', 'Neues Unternehmen'],
  ['Refresh', 'Aktualisieren'],
  ['Could not load companies. Is the backend running on port 8000?', 'Unternehmen konnten nicht geladen werden. Laeuft das Backend auf Port 8000?'],
  ['Company Profile', 'Unternehmensprofil'],
  ['Company name', 'Unternehmensname'],
  ['Slogan', 'Slogan'],
  ['Industry', 'Branche'],
  ['Brand voice', 'Markenstimme'],
  ['Company description', 'Unternehmensbeschreibung'],
  ['Target audience', 'Zielgruppe'],
  ['Mission', 'Mission'],
  ['Website', 'Website'],
  ['Country', 'Land'],
  ['Brand colors (comma separated)', 'Markenfarben (kommagetrennt)'],
  ['Upload logo', 'Logo hochladen'],
  ['Replace logo', 'Logo ersetzen'],
  ['Save the company first to enable uploads.', 'Speichere zuerst das Unternehmen, um Uploads zu aktivieren.'],
  ['AI fill', 'KI ausfuellen'],
  ['Delete', 'Loeschen'],
  ['Saving...', 'Speichert...'],
  ['Save profile', 'Profil speichern'],
  ['Create company', 'Unternehmen erstellen'],
  ['Products', 'Produkte'],
  ['Product name', 'Produktname'],
  ['Target market', 'Zielmarkt'],
  ['Product visual category', 'Visuelle Produktkategorie'],
  ['Auto detect', 'Automatisch erkennen'],
  ['Physical product', 'Physisches Produkt'],
  ['Software / SaaS', 'Software / SaaS'],
  ['AI chatbot / assistant', 'KI-Chatbot / Assistent'],
  ['Mobile app', 'Mobile App'],
  ['Professional service', 'Professionelle Dienstleistung'],
  ['Energy / thermal management', 'Energie / Waermemanagement'],
  ['Short description', 'Kurzbeschreibung'],
  ['Long description', 'Lange Beschreibung'],
  ['Features (one per line or comma)', 'Funktionen (eine pro Zeile oder Komma)'],
  ['Benefits (one per line or comma)', 'Nutzen (einer pro Zeile oder Komma)'],
  ['Keywords (comma separated)', 'Keywords (kommagetrennt)'],
  ['Cancel', 'Abbrechen'],
  ['Update product', 'Produkt aktualisieren'],
  ['Add product', 'Produkt hinzufuegen'],
  ['Upload product/reference image', 'Produkt-/Referenzbild hochladen'],
  ['Edit', 'Bearbeiten'],
  ['Brand Assets & Knowledge Base', 'Markenassets & Wissensbasis'],
  ['Upload documents, images, videos, moodboards, packaging shots, color palettes, style guides, brochures or presentations. Text files are indexed for RAG; images/videos are saved as visual references so generated creatives can follow real brand assets, product appearance, motion style and art direction.', 'Lade Dokumente, Bilder, Videos, Moodboards, Verpackungsbilder, Farbpaletten, Styleguides, Broschueren oder Praesentationen hoch. Textdateien werden fuer RAG indexiert; Bilder und Videos werden als visuelle Referenzen gespeichert, damit generierte Creatives echten Markenassets, Produktoptik, Motion-Stil und Art Direction folgen koennen.'],
  ['Analyzing...', 'Analysiert...'],
  ['Upload brand file', 'Markendatei hochladen'],
  ['No documents indexed yet.', 'Noch keine Dokumente indexiert.'],
  ['Video reference', 'Video-Referenz'],
  ['Generate Grounded Content', 'Fundierte Inhalte generieren'],
  ['Output type', 'Ausgabetyp'],
  ['Audience', 'Zielgruppe'],
  ['Product (optional)', 'Produkt (optional)'],
  ['All / none', 'Alle / keines'],
  ['Extra instructions (optional)', 'Zusaetzliche Anweisungen (optional)'],
  ['Generate', 'Generieren'],
  ['Generating...', 'Generiert...'],
  ['Copied', 'Kopiert'],
  ['Copy', 'Kopieren'],
  ['Download .txt', 'TXT herunterladen'],
  ['Grounded on', 'Fundiert auf'],
  ['source(s)', 'Quelle(n)'],
  ['Brand profile strength', 'Staerke des Markenprofils'],
  ['Excellent - the AI has rich, grounded knowledge of your brand.', 'Ausgezeichnet - die KI hat umfangreiches, fundiertes Wissen ueber deine Marke.'],
  ['Add more details, products and documents so the AI generates more accurate, on-brand content.', 'Fuege mehr Details, Produkte und Dokumente hinzu, damit die KI praezisere, markenkonforme Inhalte generiert.'],

  ['Welcome back to AI growth', 'Willkommen zurueck beim KI-Wachstum'],
  ['Start growing with AI', 'Starte Wachstum mit KI'],
  ['Create smarter campaigns in minutes.', 'Erstelle smartere Kampagnen in Minuten.'],
  ['Sign in to keep building smarter campaigns.', 'Melde dich an, um weiter smartere Kampagnen zu bauen.'],
  ['AI marketing workspace', 'KI-Marketing-Workspace'],
  ['Full name', 'Vollstaendiger Name'],
  ['Work email', 'Geschaeftliche E-Mail'],
  ['Company name', 'Unternehmensname'],
  ['Password', 'Passwort'],
  ['At least 6 characters', 'Mindestens 6 Zeichen'],
  ['Create account', 'Konto erstellen'],
  ['Creating workspace...', 'Workspace wird erstellt...'],
  ['Signing in...', 'Anmeldung laeuft...'],
  ['Continue with Google', 'Mit Google fortfahren'],
  ['No credit card required', 'Keine Kreditkarte erforderlich'],
  ['Already have an account?', 'Du hast bereits ein Konto?'],
  ["Don't have an account?", 'Du hast noch kein Konto?'],
  ['Close signup dialog', 'Registrierungsdialog schliessen'],
  ['Hide password', 'Passwort ausblenden'],
  ['Show password', 'Passwort anzeigen'],
  ['Enter your full name.', 'Gib deinen vollstaendigen Namen ein.'],
  ['Enter your company name.', 'Gib deinen Unternehmensnamen ein.'],
  ['Enter your work email.', 'Gib deine geschaeftliche E-Mail ein.'],
  ['Enter a valid work email.', 'Gib eine gueltige geschaeftliche E-Mail ein.'],
  ['Enter a password.', 'Gib ein Passwort ein.'],
  ['Use at least 6 characters.', 'Nutze mindestens 6 Zeichen.'],
  ['Signup form selected.', 'Registrierungsformular ausgewaehlt.'],
  ['Sign in form selected.', 'Anmeldeformular ausgewaehlt.'],
  ['Password is visible.', 'Passwort ist sichtbar.'],
  ['Password is hidden.', 'Passwort ist verborgen.'],
  ['Creating your AI marketing workspace.', 'Dein KI-Marketing-Workspace wird erstellt.'],
  ['Workspace ready.', 'Workspace bereit.'],
  ['Welcome back.', 'Willkommen zurueck.'],
  ['Workspace ready!', 'Workspace bereit!'],
  ['Google sign-up is not connected in this prototype yet.', 'Google-Registrierung ist in diesem Prototyp noch nicht verbunden.'],
  ['AI campaign engine', 'KI-Kampagnen-Engine'],
  ['Marketing automation that reacts in real time.', 'Marketing-Automation, die in Echtzeit reagiert.'],
  ['Audience, email, campaign and analytics cards wake up as the form is completed.', 'Zielgruppen-, E-Mail-, Kampagnen- und Analyse-Karten reagieren, waehrend das Formular ausgefuellt wird.'],
  ['Campaign', 'Kampagne'],
  ['Optimizing...', 'Optimiert...'],
  ['Live', 'Live'],
  ['Campaign setup', 'Kampagnen-Setup'],
  ['Ready', 'Bereit'],
  ['Growth campaign', 'Wachstumskampagne'],
  ['Workspace ready', 'Workspace bereit'],
  ['Setup in progress', 'Setup laeuft'],
  ['New lead detected', 'Neuer Lead erkannt'],
  ['Analyzing...', 'Analysiert...'],
  ['+18% growth', '+18% Wachstum'],
  ['ICP: SaaS teams', 'ICP: SaaS-Teams'],
  ['Segment: High intent', 'Segment: hohe Kaufabsicht'],
  ['Lead:', 'Lead:'],
  ['Email automation', 'E-Mail-Automation'],
  ['Email ready', 'E-Mail bereit'],
  ['Automating...', 'Automatisiert...'],
  ['3-step flow', '3-Schritte-Flow'],
  ['Analytics', 'Analysen'],
  ['Rising', 'Steigend'],
  ['AI Score 94', 'KI-Score 94'],
  ['Ad copy', 'Anzeigentext'],
  ['Generated', 'Generiert'],
  ['Conversions', 'Conversions'],
  ['Check field', 'Feld pruefen'],
  ['Try again', 'Erneut versuchen'],

  ['Your campaign studio is ready', 'Dein Kampagnen-Studio ist bereit'],
  ['Fill in the brief and generate to see ad creatives, copy, strategy scores and a content plan here.', 'Fuelle das Briefing aus und generiere Inhalte, um hier Creatives, Texte, Strategie-Scores und einen Content-Plan zu sehen.'],
  ['Generated Campaign', 'Generierte Kampagne'],
  ['Balanced', 'Ausgewogen'],
  ['Goal', 'Ziel'],
  ['Tone', 'Ton'],
  ['Platform', 'Plattform'],
  ['Overall', 'Gesamt'],
  ['Saved', 'Gespeichert'],
  ['Save campaign', 'Kampagne speichern'],
  ['Copy all text', 'Alle Texte kopieren'],
  ['Export / Print', 'Exportieren / Drucken'],
  ['Creatives', 'Creatives'],
  ['Strategy', 'Strategie'],
  ['Planning', 'Planung'],
  ['Feed Post', 'Feed-Post'],
  ['Sponsored', 'Gesponsert'],
  ['Edit prompt', 'Prompt bearbeiten'],
  ['Regenerating...', 'Regeneriert...'],
  ['Regenerate', 'Regenerieren'],
  ['Download', 'Herunterladen'],
  ['Story / Reel', 'Story / Reel'],
  ['Video Ad', 'Videoanzeige'],
  ['Download MP4', 'MP4 herunterladen'],
  ['Distinct Creative Options', 'Unterschiedliche Creative-Optionen'],
  ['Each image below was rendered with a different art direction, layout, composition, typography mood, color treatment and product positioning.', 'Jedes Bild unten wurde mit anderer Art Direction, anderem Layout, anderer Komposition, Typografie-Stimmung, Farbbehandlung und Produktpositionierung gerendert.'],
  ['Creative & Image Direction', 'Creative- und Bildrichtung'],
  ['Design Direction', 'Designrichtung'],
  ['Image Idea', 'Bildidee'],
  ['Image Generation Prompt', 'Prompt fuer Bildgenerierung'],
  ['Advertising Copy', 'Anzeigentext'],
  ['Social Content', 'Social Content'],
  ['Sales Email', 'Sales-E-Mail'],
  ['Subject', 'Betreff'],
  ['AI Quality Scores', 'KI-Qualitaetsscores'],
  ['Relevance', 'Relevanz'],
  ['Creativity', 'Kreativitaet'],
  ['Clarity', 'Klarheit'],
  ['Brand fit', 'Markenfit'],
  ['Conversion', 'Conversion'],
  ['Ethical safety', 'Ethische Sicherheit'],
  ['Research Notes', 'Research Notes'],
  ['Approach', 'Ansatz'],
  ['Persuasion', 'Ueberzeugung'],
  ['Rationale', 'Begruendung'],
  ['Testing', 'Testing'],
  ['Risks', 'Risiken'],
  ['Grounding Sources', 'Quellen fuer Fundierung'],
  ['These are the uploaded company knowledge snippets used to ground the campaign.', 'Das sind die hochgeladenen Wissensausschnitte, mit denen die Kampagne fundiert wurde.'],
  ['Source', 'Quelle'],
  ['Match', 'Uebereinstimmung'],
  ['Improvement Tips', 'Verbesserungstipps'],
  ['Video Storyboard', 'Video-Storyboard'],
  ['Content Calendar', 'Content-Kalender'],
  ['Copy all text copied', 'Alle Kampagnentexte kopiert'],
  ['All campaign text copied', 'Alle Kampagnentexte kopiert'],
  ['Allow pop-ups to export', 'Pop-ups zum Exportieren erlauben'],
  ['Regenerated', 'Regeneriert'],
  ['Could not regenerate this field', 'Dieses Feld konnte nicht regeneriert werden'],
  ['Failed to regenerate square image.', 'Quadratisches Bild konnte nicht regeneriert werden.'],
  ['Failed to regenerate portrait image.', 'Hochformat-Bild konnte nicht regeneriert werden.'],
  ['Copy to clipboard', 'In Zwischenablage kopieren'],
  ['Regenerate with AI', 'Mit KI regenerieren'],
  ['Square feed mockup', 'Quadratisches Feed-Mockup'],
  ['Portrait story mockup', 'Story-Mockup im Hochformat'],
  ['creative direction', 'Creative-Richtung'],

  ['Prompt Strategy Experiment', 'Prompt-Strategie-Experiment'],
  ['A/B comparison of AI-generated marketing variants', 'A/B-Vergleich KI-generierter Marketingvarianten'],
  ['Best strategy', 'Beste Strategie'],
  ['Winner', 'Gewinner'],
  ['Overall AI score', 'Gesamter KI-Score'],
  ['Ethics', 'Ethik'],
  ['Preview this variant', 'Diese Variante ansehen'],

  ['Human Feedback for Thesis Evaluation', 'Menschliches Feedback fuer Thesis-Evaluation'],
  ['Save a simple human rating for the selected campaign. Later, you can compare human ratings with AI evaluation scores.', 'Speichere eine einfache menschliche Bewertung fuer die ausgewaehlte Kampagne. Spaeter kannst du menschliche Bewertungen mit KI-Scores vergleichen.'],
  ['Overall human rating', 'Menschliche Gesamtbewertung'],
  ['5 - Very good', '5 - Sehr gut'],
  ['4 - Good', '4 - Gut'],
  ['3 - Average', '3 - Durchschnittlich'],
  ['2 - Weak', '2 - Schwach'],
  ['1 - Poor', '1 - Schlecht'],
  ['Feedback note', 'Feedback-Notiz'],
  ['Save feedback', 'Feedback speichern'],
  ['Saving feedback...', 'Feedback wird gespeichert...'],
  ['Feedback saved locally. You can use this later for thesis evaluation.', 'Feedback lokal gespeichert. Du kannst es spaeter fuer die Thesis-Evaluation nutzen.'],
  ['Could not save feedback. Please check the backend terminal.', 'Feedback konnte nicht gespeichert werden. Bitte pruefe das Backend-Terminal.'],

  ['Are you sure?', 'Bist du sicher?'],
  ['Confirm', 'Bestaetigen'],
  ['Close', 'Schliessen'],
  ['Delete product?', 'Produkt loeschen?'],
  ['This product will be removed from your brand profile.', 'Dieses Produkt wird aus deinem Markenprofil entfernt.'],
  ['Delete document?', 'Dokument loeschen?'],
  ['This document and its indexed knowledge will be removed.', 'Dieses Dokument und sein indexiertes Wissen werden entfernt.'],
  ['Delete this company?', 'Dieses Unternehmen loeschen?'],
  ['This permanently removes the company and ALL its products, documents and knowledge. This cannot be undone.', 'Dies entfernt das Unternehmen und ALLE Produkte, Dokumente und Wissensinhalte dauerhaft. Das kann nicht rueckgaengig gemacht werden.'],
  ['Delete everything', 'Alles loeschen'],
  ['Product updated', 'Produkt aktualisiert'],
  ['Product added', 'Produkt hinzugefuegt'],
  ['Product reference image uploaded', 'Produkt-Referenzbild hochgeladen'],
  ['Product deleted', 'Produkt geloescht'],
  ['Could not delete product', 'Produkt konnte nicht geloescht werden'],
  ['Document deleted', 'Dokument geloescht'],
  ['Could not delete document', 'Dokument konnte nicht geloescht werden'],
  ['Company deleted', 'Unternehmen geloescht'],
  ['Could not delete company', 'Unternehmen konnte nicht geloescht werden'],
  ['Enter a company name first', 'Gib zuerst einen Unternehmensnamen ein'],
  ['AI filled the empty profile fields', 'KI hat die leeren Profilfelder ausgefuellt'],
  ['Autofill failed', 'Automatisches Ausfuellen fehlgeschlagen'],
  ['Enter a product name first', 'Gib zuerst einen Produktnamen ein'],
  ['AI suggested product details', 'KI hat Produktdetails vorgeschlagen'],
  ['Create/select a company first.', 'Erstelle oder waehle zuerst ein Unternehmen aus.'],
  ['Logo uploaded.', 'Logo hochgeladen.'],

  ['Assets', 'Assets'],
  ['History', 'Verlauf'],
  ['Undo', 'Rueckgaengig'],
  ['Redo', 'Wiederholen'],
  ['Basic', 'Basis'],
  ['Adjust', 'Anpassen'],
  ['Filters', 'Filter'],
  ['Text', 'Text'],
  ['Shapes', 'Formen'],
  ['Layers', 'Ebenen'],
  ['Export', 'Exportieren'],
  ['Select an image from your campaign assets or upload a file', 'Waehle ein Bild aus deinen Kampagnenassets oder lade eine Datei hoch'],
  ['Apply Crop', 'Zuschnitt anwenden'],
  ['Transform', 'Transformieren'],
  ['Cancel Crop', 'Zuschnitt abbrechen'],
  ['Crop', 'Zuschneiden'],
  ['Rotate R', 'Rechts drehen'],
  ['Rotate L', 'Links drehen'],
  ['Flip H', 'Horizontal spiegeln'],
  ['Flip V', 'Vertikal spiegeln'],
  ['Zoom +', 'Zoom +'],
  ['Zoom -', 'Zoom -'],
  ['Reset', 'Zuruecksetzen'],
  ['Zoom', 'Zoom'],
  ['Adjustments', 'Anpassungen'],
  ['Brightness', 'Helligkeit'],
  ['Contrast', 'Kontrast'],
  ['Saturation', 'Saettigung'],
  ['Sharpness', 'Schaerfe'],
  ['Opacity', 'Deckkraft'],
  ['Reset Adjustments', 'Anpassungen zuruecksetzen'],
  ['None', 'Keiner'],
  ['Blur', 'Weichzeichnen'],
  ['Vintage', 'Vintage'],
  ['B & W', 'S/W'],
  ['Warm', 'Warm'],
  ['Cool', 'Kuehl'],
  ['Text Tools', 'Textwerkzeuge'],
  ['Enter text...', 'Text eingeben...'],
  ['Bg', 'Hintergrund'],
  ['Rotation', 'Drehung'],
  ['Padding', 'Innenabstand'],
  ['Box Width (0=Auto)', 'Boxbreite (0=Auto)'],
  ['Add Text', 'Text hinzufuegen'],
  ['Delete Selected Text', 'Ausgewaehlten Text loeschen'],
  ['Rectangle', 'Rechteck'],
  ['Circle', 'Kreis'],
  ['Arrow', 'Pfeil'],
  ['Line', 'Linie'],
  ['Width', 'Breite'],
  ['No layers yet. Add text or shapes.', 'Noch keine Ebenen. Fuege Text oder Formen hinzu.'],
  ['Bring Forward', 'Nach vorne bringen'],
  ['Send Backward', 'Nach hinten senden'],
  ['Export as', 'Exportieren als'],
  ['System & Standard', 'System & Standard'],
  ['Cursive & Script', 'Schreibschrift & Script'],
  ['Bold & Display', 'Fett & Display'],
  ['Sans-Serif', 'Sans-Serif'],
  ['Serif & Mono', 'Serif & Mono'],

  ['Back 10s', '10s zurueck'],
  ['Forward 10s', '10s vor'],
  ['Pause', 'Pause'],
  ['Play', 'Abspielen'],
  ['Unmute', 'Ton an'],
  ['Mute', 'Stumm'],
  ['Volume', 'Lautstaerke'],
  ['Exit Fullscreen', 'Vollbild beenden'],
  ['Fullscreen', 'Vollbild'],
  ['Scene', 'Szene'],

  ['Saved company profile in use', 'Gespeichertes Unternehmensprofil wird genutzt'],
  ['Increase product awareness and online sales', 'Produktbekanntheit und Online-Verkaeufe steigern'],
  ['Generate leads', 'Leads generieren'],
  ['Launch a new product', 'Neues Produkt einfuehren'],
  ['Improve brand trust', 'Markenvertrauen verbessern'],
  ['Promote a discount campaign', 'Rabattkampagne bewerben'],
  ['Modern, friendly and motivating', 'Modern, freundlich und motivierend'],
  ['Professional and trustworthy', 'Professionell und vertrauenswuerdig'],
  ['Luxury and elegant', 'Luxurioes und elegant'],
  ['Funny and casual', 'Locker und humorvoll'],
  ['Emotional and storytelling', 'Emotional und storytelling-orientiert'],
  ['Benefit-Focused', 'Nutzenfokussiert'],
  ['Trust-Focused', 'Vertrauensfokussiert'],
  ['Premium modern social ad with gradients and clean typography', 'Premium Social Ad mit Verlaeufen und klarer Typografie'],
  ['Minimal luxury poster with elegant negative space', 'Minimalistisches Luxusposter mit elegantem Weissraum'],
  ['Bold high-contrast product hero ad', 'Mutige Produkt-Hero-Anzeige mit starkem Kontrast'],
  ['Tech editorial dashboard-style creative', 'Tech-Editorial-Creative im Dashboard-Stil'],
  ['Cinematic launch ad with dramatic product spotlight', 'Cinematic Launch Ad mit dramatischem Produkt-Spotlight'],
  ['Emotional lifestyle storytelling scene', 'Emotionale Lifestyle-Storytelling-Szene'],
  ['Playful colorful social media creative', 'Verspieltes, farbenfrohes Social-Media-Creative'],
  ['Professional B2B trust-building visual', 'Professionelles B2B-Visual fuer Vertrauensaufbau'],
  ['Brand', 'Marke'],
  ['Product', 'Produkt'],
  ['Colors', 'Farben'],
  ['Edit any of these in the Brand Hub. The creative settings in the next steps still apply.', 'Bearbeite diese Angaben im Brand Hub. Die Creative-Einstellungen in den naechsten Schritten gelten weiterhin.'],
  ['Use my logo, product images and uploaded brand files inside the generated creatives', 'Meine Logos, Produktbilder und hochgeladenen Markendateien in den generierten Creatives verwenden'],
  ['Saved Company Mode', 'Gespeicherter Unternehmensmodus'],
  ['Manual brand fields are ignored in this mode.', 'Manuelle Markenfelder werden in diesem Modus ignoriert.'],
  ['Target audience and key benefits come from', 'Zielgruppe und Kernnutzen kommen aus'],
  ['Use the fields below to shape this specific campaign.', 'Nutze die Felder unten, um diese konkrete Kampagne zu formen.'],
  ['Auto (smart)', 'Auto (smart)'],
  ['Realistic', 'Realistisch'],
  ['Animated', 'Animiert'],
  ['Auto uses realistic photography for grounded brands and animated illustration for unknown ones. Animated locks both image and video generation to an animated/CGI style only.', 'Auto nutzt realistische Fotografie fuer fundierte Marken und animierte Illustration fuer unbekannte. Animiert beschraenkt Bild- und Videogenerierung auf animierten/CGI-Stil.'],
  ['Auto art direction', 'Automatische Art Direction'],
  ['Minimal luxury', 'Minimaler Luxus'],
  ['Bold FMCG / product hero', 'Mutiger FMCG-/Produkt-Hero'],
  ['Editorial heritage', 'Editorial Heritage'],
  ['Object metaphor', 'Objektmetapher'],
  ['Sport energy', 'Sport-Energie'],
  ['Food offer', 'Food-Angebot'],
  ['Tech editorial', 'Tech Editorial'],
  ['Cinematic launch', 'Cinematic Launch'],
  ['Classic long-copy', 'Klassische Long Copy'],
  ['This controls the poster/layout style used by the prompt and renderer.', 'Dies steuert den Poster-/Layoutstil, den Prompt und Renderer verwenden.'],
  ['Each option uses a different art direction, layout, composition, typography mood and visual treatment.', 'Jede Option nutzt andere Art Direction, anderes Layout, andere Komposition, Typografie-Stimmung und visuelle Behandlung.'],
  ['Preparing generation...', 'Generierung wird vorbereitet...'],
  ['Connecting to generation engine...', 'Verbindung zur Generierungs-Engine...'],
  ['Generating locally...', 'Generiert lokal...'],
  ['Campaign job queued', 'Kampagnenjob eingereiht'],
  ['Campaign generated!', 'Kampagne generiert!'],
  ['Could not generate campaign. Please check if the backend is running on port 8000.', 'Kampagne konnte nicht generiert werden. Bitte pruefe, ob das Backend auf Port 8000 laeuft.'],
  ['Could not run prompt experiment. Please check if the backend is running on port 8000.', 'Prompt-Experiment konnte nicht gestartet werden. Bitte pruefe, ob das Backend auf Port 8000 laeuft.'],
  ['Campaign saved', 'Kampagne gespeichert'],
  ['Could not save campaign locally. Please check the backend terminal.', 'Kampagne konnte lokal nicht gespeichert werden. Bitte pruefe das Backend-Terminal.'],
  ['Could not save campaign', 'Kampagne konnte nicht gespeichert werden'],

  ['Custom Web App Development', 'Individuelle Web-App-Entwicklung'],
  ['AI ad & campaign generation', 'KI-Anzeigen- und Kampagnengenerierung'],
  ['Brand knowledge base (RAG) setup', 'Einrichtung einer Marken-Wissensbasis (RAG)'],
  ['AI image & video creatives', 'KI-Bild- und Video-Creatives'],
  ['Copywriting automation', 'Copywriting-Automation'],
  ['Enterprise / custom plan', 'Enterprise / individueller Plan'],
  ['e.g., Katherine Bell', 'z. B. Katherine Bell'],
  ['e.g., katherine@company.com', 'z. B. katherine@unternehmen.com'],
  ['e.g., Acme Corp', 'z. B. Acme GmbH'],
  ["Your industry, products, target audience, and what you'd like to generate first...", 'Deine Branche, Produkte, Zielgruppe und was du zuerst generieren moechtest...'],
  ['e.g. confident, warm, expert', 'z. B. selbstbewusst, warm, kompetent'],
  ['e.g. highlight the spring promotion, keep it under 100 words', 'z. B. Fruehlingsaktion hervorheben, unter 100 Woertern bleiben'],
  ["Paste past successful ad copy so the AI can clone your brand's writing style...", 'Fuege fruehere erfolgreiche Anzeigentexte ein, damit die KI deinen Schreibstil uebernehmen kann...'],
];

function normalize(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function addPair(map, from, to) {
  const key = normalize(from);
  const value = normalize(to);
  if (key && value && key !== value) map.set(key, value);
}

function buildDictionary(language) {
  const map = new Map();
  const source = language === 'de' ? TRANSLATIONS.en : TRANSLATIONS.de;
  const target = language === 'de' ? TRANSLATIONS.de : TRANSLATIONS.en;

  Object.entries(source).forEach(([key, value]) => addPair(map, value, target[key] || value));
  UI_PHRASES.forEach(([english, german]) => {
    if (language === 'de') addPair(map, english, german);
    else addPair(map, german, english);
  });

  // Common mojibake variants found in older JSX text.
  if (language === 'de') {
    addPair(map, '\u00e2\u20ac\u201d Select a company \u00e2\u20ac\u201d', '- Unternehmen auswaehlen -');
    addPair(map, 'New company \u00e2\u20ac\u201d fill the profile and click Save.', 'Neues Unternehmen - fuelle das Profil aus und klicke auf Speichern.');
    addPair(map, 'Excellent \u00e2\u20ac\u201d the AI has rich, grounded knowledge of your brand.', 'Ausgezeichnet - die KI hat umfangreiches, fundiertes Wissen ueber deine Marke.');
    addPair(map, '\u00e2\u0153\u201c', 'Ausgewaehlt');
    addPair(map, '\u00e2\u0153\u017d', 'Manuell');
    addPair(map, '\u00e2\u20ac\u201d', '-');
    addPair(map, '\u00e2\u02c6\u2019', '-');
  }

  return map;
}

function dynamicTranslate(text, language) {
  if (language !== 'de') return null;
  const value = normalize(text);

  const sourceMatch = value.match(/^Grounded on (\d+) source\(s\)$/);
  if (sourceMatch) return `Fundiert auf ${sourceMatch[1]} Quelle(n)`;

  const savedCompany = value.match(/^Saved company profile for (.+)\.$/);
  if (savedCompany) return `Unternehmensprofil fuer ${savedCompany[1]} gespeichert.`;

  const createdCompany = value.match(/^Created company (.+)\.$/);
  if (createdCompany) return `Unternehmen ${createdCompany[1]} erstellt.`;

  const editing = value.match(/^Editing "(.+)". Update the fields and save\.$/);
  if (editing) return `"${editing[1]}" wird bearbeitet. Aktualisiere die Felder und speichere.`;

  const saveCompanyError = value.match(/^Could not save company: (.+)$/);
  if (saveCompanyError) return `Unternehmen konnte nicht gespeichert werden: ${saveCompanyError[1]}`;

  const saveProductError = value.match(/^Could not save product: (.+)$/);
  if (saveProductError) return `Produkt konnte nicht gespeichert werden: ${saveProductError[1]}`;

  const imageUploadError = value.match(/^Image upload failed: (.+)$/);
  if (imageUploadError) return `Bildupload fehlgeschlagen: ${imageUploadError[1]}`;

  const logoUploadError = value.match(/^Logo upload failed: (.+)$/);
  if (logoUploadError) return `Logo-Upload fehlgeschlagen: ${logoUploadError[1]}`;

  const generationError = value.match(/^Generation failed: (.+)$/);
  if (generationError) return `Generierung fehlgeschlagen: ${generationError[1]}`;

  const uploadError = value.match(/^Upload failed: (.+)$/);
  if (uploadError) return `Upload fehlgeschlagen: ${uploadError[1]}`;

  const matchScore = value.match(/^Match (\d+)%$/);
  if (matchScore) return `Uebereinstimmung ${matchScore[1]}%`;

  const layers = value.match(/^Layers \((\d+)\)$/);
  if (layers) return `Ebenen (${layers[1]})`;

  const applyCrop = value.match(/^Apply Crop \((.+)\)$/);
  if (applyCrop) return `Zuschnitt anwenden (${applyCrop[1]})`;

  const exportAs = value.match(/^Export as (PNG|JPG|WEBP)$/);
  if (exportAs) return `Exportieren als ${exportAs[1]}`;

  const drawShape = value.match(/^Click and drag on canvas to draw a (.+)$/);
  if (drawShape) return `Klicke und ziehe auf der Leinwand, um ${drawShape[1]} zu zeichnen`;

  const scene = value.match(/^Scene (\d+)$/);
  if (scene) return `Szene ${scene[1]}`;

  const source = value.match(/^Source (\d+)$/);
  if (source) return `Quelle ${source[1]}`;

  const creativeOption = value.match(/^Creative option (\d+)$/);
  if (creativeOption) return `Creative-Option ${creativeOption[1]}`;

  const imageCount = value.match(/^(\d+) image(s?)$/);
  if (imageCount) return `${imageCount[1]} Bild${imageCount[1] === '1' ? '' : 'er'}`;

  const jobStatus = value.match(/^Job (.+): (.+)$/);
  if (jobStatus) return `Job ${jobStatus[1]}: ${jobStatus[2]}`;

  return null;
}

function translateValue(value, dictionary, language) {
  const trimmed = normalize(value);
  if (!trimmed) return value;

  const translated = dictionary.get(trimmed) || dynamicTranslate(trimmed, language);
  if (!translated || translated === trimmed) return value;

  return String(value).replace(String(value).trim(), translated);
}

function shouldSkipTextElement(element) {
  if (!element) return true;
  if (SKIP_TEXT_TAGS.has(element.tagName)) return true;
  return Boolean(element.closest('[data-no-translate]'));
}

function shouldSkipAttributeElement(element) {
  if (!element) return true;
  if (SKIP_ATTRIBUTE_TAGS.has(element.tagName)) return true;
  return Boolean(element.closest('[data-no-translate]'));
}

function translateTree(root, dictionary, language) {
  if (!root) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent || shouldSkipTextElement(parent)) return NodeFilter.FILTER_REJECT;
      if (!normalize(node.nodeValue)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);
  textNodes.forEach((node) => {
    const next = translateValue(node.nodeValue, dictionary, language);
    if (next !== node.nodeValue) node.nodeValue = next;
  });

  const attrSelector = ATTRIBUTES.map((attribute) => `[${attribute}]`).join(',');
  root.querySelectorAll(attrSelector).forEach((element) => {
    if (shouldSkipAttributeElement(element)) return;
    ATTRIBUTES.forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (!value) return;
      const next = translateValue(value, dictionary, language);
      if (next !== value) element.setAttribute(attribute, next);
    });
  });
}

export function useDomTranslator(language) {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const root = document.querySelector('.app-shell') || document.body;
    const dictionary = buildDictionary(language);
    let frame = 0;

    const run = () => translateTree(root, dictionary, language);
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        run();
      });
    };

    run();

    const observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRIBUTES,
    });

    return () => {
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [language]);
}
